import { render, staticRenderFns } from "./ViewTemplate.vue?vue&type=template&id=45b7c5c2&scoped=true"
import script from "./ViewTemplate.vue?vue&type=script&lang=js"
export * from "./ViewTemplate.vue?vue&type=script&lang=js"
import style0 from "./ViewTemplate.vue?vue&type=style&index=0&id=45b7c5c2&prod&lang=scss&scoped=true"
import style1 from "./ViewTemplate.vue?vue&type=style&index=1&id=45b7c5c2&prod&lang=scss&scoped=true"
import style2 from "./ViewTemplate.vue?vue&type=style&index=2&id=45b7c5c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7c5c2",
  null
  
)

export default component.exports